var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoliday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 5.99999C9.32502 12.3417 6.33335 16.8333 6.33335 16.8333H8.83335C10.4 12 9.66669 8.57499 9.25002 6.83332L8.00002 5.99999ZM11.05 4.46666C11.1917 4.64166 11.3334 4.82499 11.4417 5.01666C12.8667 7.27499 12.5834 10.125 10.9167 12.05C11.6167 10.3417 11.5167 8.32499 10.4584 6.64166C10.3917 6.53332 10.3167 6.44166 10.25 6.34166C9.75835 5.64999 9.13335 5.09999 8.45002 4.69166C6.05002 5.45832 4.31669 7.69999 4.31669 10.35C4.31669 10.9667 4.40835 11.5583 4.57502 12.1083C3.87502 11.1333 3.46669 9.94166 3.46669 8.65832C3.46669 6.69999 4.41669 4.96666 5.87502 3.88332C4.66669 3.79166 3.38335 4.05832 2.26669 4.74999C1.75002 5.09166 1.30002 5.48332 0.916687 5.92499C1.37502 4.81666 2.16669 3.82499 3.25002 3.14166C4.50002 2.35832 5.91669 2.09999 7.28335 2.29999C6.94169 1.83332 6.52502 1.39166 6.02502 0.99999C5.54169 0.64999 5.01669 0.366656 4.46669 0.166656C5.66669 0.19999 6.86669 0.583323 7.89169 1.35832C8.41669 1.74999 8.83335 2.22499 9.16669 2.72499C9.25002 2.72499 9.32502 2.71666 9.40835 2.71666C12.075 2.71666 14.3334 4.47499 15.0834 6.89999C14.15 5.58332 12.7084 4.69166 11.05 4.46666Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoliday);
export default __webpack_public_path__ + "static/media/holiday.3759ab5d.svg";
export { ForwardRef as ReactComponent };